import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    // primary: {
    //   main: "#3009f5",
    // },
    secondary: {
      main: "#f50057",
    },
    // background: {
    //   default: "#606060",
    //   paper: "#3c3c3c",
    // },
  },
  typography: {
    fontFamily: "Lato",
    fontSize: 16,
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    // Name of the component
    MuiButtonBase: {
      defaultProps: {
        // The props to change the default for.
        // disableRipple: true, // No more ripple, on the whole application 💣!
      },
    },
    MuiButton: {
      styleOverrides: ({ ownerState }) => ({
        ...(ownerState.variant === "contained" &&
          ownerState.color === "primary" && {
            background: "linear-gradient(90deg, rgba(27,27,251,1) 22%, rgba(209,18,241,1) 71%)",
            border: 0,
            borderRadius: 10,
            color: "white",
            height: 48,
            padding: "0 30px",
          }),
      }),
    },
  },
  spacing: 8,
});

export default theme;
